<div class="info-banner-container" [ngClass]="infoBannerClass">
  <p class="icon" [ngClass]="[iconClass, styleClass]" [class.transparent]="!banner?.icon" ></p>
  <p *ngIf="banner?.firstLine" class="first-line" [ngClass]="[styleClass, font?.size]" [innerHTML]="banner?.firstLine | translate"></p>
  <p *ngIf="banner?.secondLine" class="second-line" [ngClass]="[styleClass, font?.size]" [innerHTML]="banner?.secondLine | translate"></p>
</div>
